// extracted by mini-css-extract-plugin
export default {"successModalMessage":"TOKzN","successModalImg":"O7rLS"};